import { Global, css } from '@emotion/react';
import React from 'react';

import { Mode } from 'src/modules/designStudio/providers';
import { useMode, useQueryParam } from 'src/shared/hooks';

const ALLOW_HIDDEN_COOKIE_BANNER_MODES = [Mode.PREVIEW, Mode.GUEST];

const hideOnetrustStyle = css`
  #onetrust-consent-sdk {
    display: none;
  }
`;

const useShouldHideCookieBanner = () => {
  const mode = useMode();
  const hideCookieBannerQueryParam = useQueryParam('hide-cookie-banner');

  if (!ALLOW_HIDDEN_COOKIE_BANNER_MODES.includes(mode)) {
    return false;
  }
  if (mode === Mode.PREVIEW) {
    return true;
  }

  return hideCookieBannerQueryParam === 'true';
};

/**
 * Hides cookie banner based on mode and query param criteria. This does render correctly server side so the styling
 * should be present immediately on page load.
 */
export const MaybeHideCookieBanner = () => {
  const shouldHideCookieBanner = useShouldHideCookieBanner();
  if (!shouldHideCookieBanner) {
    return null;
  }

  return <Global styles={hideOnetrustStyle} />;
};
